import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import secuureLogoFooter from "../images/vittaLogo.svg";
import { useTranslation } from "react-i18next";

const Footer = ({ headerHeight = 0, sectionRef }) => {
  const { t } = useTranslation();
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offsetTop - headerHeight,
        behavior: "smooth",
      });
      return;
    }
  };

  return (
    <div className="container mx-auto px-2  xl:max-w-[1000px] 3xl:max-w-[1400px]">
      <div className="mx-0 pt-[40px] pr-5 pb-0 pl-5 sm:pr-10 sm:pb-0 sm:pl-10 sm:mx-auto bg-[#F5F5F5] rounded-t-[60px]">
        <div className="flex justify-center lg:justify-between flex-col lg:flex-row">
          <div className="mb-6 2xl:mb-0 logo-spacing ">
            <div className="flex flex-col mb-3">
              <img
                draggable="false"
                src={secuureLogoFooter}
                className="h-[55px] sm:h-[40px] md:h-[60px] mr-3"
                alt="secuureLogoFooter"
              />
            </div>
            <div className="text-center">
              {/* <div className="sora text-[#757575] text-[14px] mb-1">
                Sophia Antipolis, France
              </div> */}
             {/* <br/> */}
              {/* <div className="sora text-[#757575] text-[14px] mb-1">
              2093, Philadelphia Pike
              </div>
              <div className="sora text-[#757575] text-[14px] mb-1">
              19703 Delaware, USA
              </div> */}
              <div className="sora text-[#757575] text-[14px] mb-1">
              Delaware, USA
              </div>
              
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 xl:gap-7">
            {/* grid grid-cols-2 gap-2 sm:gap-4 sm:gap-8 lg:gap-40 sm:grid-cols-3 */}
            <div>
              <h2 className="sora mb-1 lg:mb-5 text-sm text-[16px] text-[#141619] font-[700]">
                {t("platform")}
              </h2>
              <ul className="text-gray-500 dark:text-gray-400 font-medium">
                <li
                  className="sm:mb-1"
                  onClick={() => handleScroll("Platform")}
                >
                  <Link
                    to="/solutions#Platform"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("omni_platform")}
                  </Link>
                </li>
                <li
                  className="sm:mb-1"
                  onClick={() => handleScroll("OmniAiChatbot")}
                >
                  <Link
                    to="/solutions#OmniAiChatbot"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("omni_ai_platform")}
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="sora mb-1 lg:mb-5  text-sm text-[16px] text-[#141619] font-[700]">
                {t("reporting")}
              </h2>
              <ul className="text-gray-500 dark:text-gray-400 font-medium">
                <li className="sm:mb-1 " onClick={() => handleScroll("Ifrs9")}>
                  <Link
                    to="/solutions#Ifrs9"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("ifrs9")}
                  </Link>
                </li>
                {/* <li className="  sm:mb-4 " onClick={() => handleScroll()}>
                  <Link
                    to="/terms-and-conditions"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    Terms & Conditions
                  </Link>
                </li> */}
                <li className="sm:mb-1 " onClick={() => handleScroll("Basel3")}>
                  <Link
                    to="/solutions#Basel3"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("basel")}
                  </Link>
                </li>
                <li
                  className="sm:mb-1 "
                  onClick={() => handleScroll("BusinessPerformance")}
                >
                  <Link
                    to="/solutions#BusinessPerformance"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("business_performance")}
                  </Link>
                </li>
                <li className="sm:mb-1 " onClick={() => handleScroll("Esg")}>
                  <Link
                    to="/solutions#Esg"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("esg")}
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="sora mb-1 lg:mb-5 text-sm sm:mt-0 text-[16px] text-[#141619] font-[700]">
                {t("data_warehousing")}
              </h2>
              <ul className="text-gray-500 dark:text-gray-400 font-medium">
                <li
                  className="sm:mb-1 "
                  onClick={() => handleScroll("FinancialData")}
                >
                  <Link
                    to="/solutions#FinancialData"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("financial_data")}
                  </Link>
                </li>
                <li
                  className="sm:mb-1 "
                  onClick={() => handleScroll("RiskData")}
                >
                  <Link
                    to="/solutions#RiskData"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("risk_data")}
                  </Link>
                </li>
                <li
                  className="sm:mb-1 "
                  onClick={() => handleScroll("ESGData")}
                >
                  <Link
                    to="/solutions#ESGData"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("esg_data")}
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div>
              <h2 className="mb-1 lg:mb-5 text-sm font-semibold text-[16px] text-[#141619] font-[700]">
                Services
              </h2>
              <ul className="text-gray-500 dark:text-gray-400 font-medium">
                <li className="sm:mb-1 " onClick={() => handleScroll()}>
                  <Link
                    to="/"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    Service Consulting
                  </Link>
                </li>
                <li className="sm:mb-1 " onClick={() => handleScroll()}>
                  <Link
                    to="/"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    Solution Integration
                  </Link>
                </li>
                <li className="sm:mb-1" onClick={() => handleScroll()}>
                  <Link
                    to="/"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    Support Management
                  </Link>
                </li>
              </ul>
            </div> */}
            <div>
              <h2 className="sora mb-1 lg:mb-5  text-sm text-[16px] text-[#141619] font-[700]">
                {t("team")}
              </h2>
              <ul className="text-gray-500 dark:text-gray-400 font-medium">
                <li className="sm:mb-1 " onClick={() => handleScroll("People")}>
                  <Link
                    to="/team#People"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("people")}
                  </Link>
                </li>
                <li
                  className="sm:mb-1 "
                  onClick={() => handleScroll("OurCoreValues")}
                >
                  <Link
                    to="/team#OurCoreValues"
                    className="sora hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    {t("our_core_values")}
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div>
              <h2 className="mb-1 lg:mb-5 text-sm mt-2 sm:mt-0 font-semibold text-[16px] text-[#141619] font-[700]">
                Resources
              </h2>
              <ul className="text-gray-500 dark:text-gray-400 font-medium">
                <li className="sm:mb-1 " onClick={() => handleScroll()}>
                  <Link
                    to="/"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    Case study
                  </Link>
                </li>
                <li className="sm:mb-1 " onClick={() => handleScroll()}>
                  <Link
                    to="/"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    Insights
                  </Link>
                </li>
                <li className="sm:mb-1 " onClick={() => handleScroll()}>
                  <Link
                    to="/"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    Events
                  </Link>
                </li>
                <li className="sm:mb-1 " onClick={() => handleScroll()}>
                  <Link
                    to="/"
                    className="hover:underline text-[#757575] text-[14px] font-[400]"
                  >
                    News
                  </Link>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto bg-[#BDBDBD] h-[2px] lg:mt-8 mb-0" />
        <div className="sm:flex sm:items-center sm:justify-between pt-5 pb-5">
          <div className="flex flex-col items-center gap-3 sm:flex-row sm:items-start sm:gap-11 justify-between">
            <Link
              onClick={() => handleScroll()}
              to="/contact-us"
              className="sora text-sm sm:text-center text-[#595959] text-[16px] font-[400]"
            >
              {t("contact")}
            </Link>
            <Link
              onClick={() => handleScroll()}
              to="/terms-of-use"
              className="sora text-sm  sm:text-center text-[#595959] text-[16px] font-[400] cursor-pointer"
            >
              {t("terms_of_use")}
            </Link>
            <Link
              onClick={() => handleScroll()}
              to="/privacy-policy"
              className="sora text-sm sm:text-center text-[#595959] text-[16px] font-[400] cursor-pointer"
            >
              {t("privacy")}
            </Link>
          </div>
          <div className="flex mt-[20px] sm:mt-[0px] justify-center">
            <span className="sora mr-[4px] pt-[2px] text-sm  sm:text-center text-[#000] text-[18px] font-[400]">
              ©
            </span>
            <span className="sora text-sm sm:text-center text-[#000] text-[16px] font-[400]">
              {new Date().getFullYear()} VITTA {t("technology")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
